import { toast } from "react-toastify";
import api from "./api/api";

export const ServiceResumoDesk = {
  listTasks: async (payload: any) => {
    try {
      const res = await api.post(`/tarefas/filter`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getTaskById: async (id: any) => {
    try {
      const res = await api.get(`/tarefas/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addTasks: async (payload: any) => {
    try {
      const res = await api.post("/tarefas", payload);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  editTasks: async (payload: any, id: any) => {
    try {
      const res = await api.put(`/tarefas/${id}`, payload);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  delTasks: async (id: any) => {
    try {
      const res = await api.delete(`/tarefas/${id}`);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      return error.response;
    }
  },
  myTasks: async (payload: any) => {
    try {
      const res = await api.post("/tarefas/myTasks", payload);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  subTask: async (id: any) => {
    try {
      const res = await api.get(`/subtarefas/${id}`);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  subTaskadd: async (payload: any) => {
    try {
      const res = await api.post("/subtarefas", payload);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  subTaskedit: async (payload: any, id: any) => {
    try {
      const res = await api.put(`/subtarefas/${id}`, payload);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  subTaskdel: async (id: any) => {
    try {
      const res = await api.delete(`/subtarefas/${id}`);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      return error.response;
    }
  },
  listTypesTarefa: async () => {
    try {
      const res = await api.get(`/typesTarefa/?page=1&perPage=99`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  listTypesPagamentoTarefa: async () => {
    try {
      const res = await api.get(`/payment-types`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getAllNotas: async (page: number, perPage: number) => {
    try {
      const res = await api.get(`/notas?page=${page}&perPage=${perPage}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  listNotas: async (payload: any) => {
    try {
      const res = await api.post(`/notas/filter`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addNotas: async (payload: any, files?: FileList | Blob | null) => {
    try {
      let body: any = payload;
      const config: any = {};

      if (files) {
        const formData = new FormData();
        Object.entries(payload).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            formData.append(
              key,
              Array.isArray(value) ? JSON.stringify(value) : String(value),
            );
          }
        });
        if (files instanceof Blob) {
          formData.append("files", files, "audio.webm");
        } else {
          Array.from(files).forEach((file) => formData.append("files", file));
        }
        body = formData;
        config.headers = { "Content-Type": "multipart/form-data" };
      }

      const res = await api.post("/notas", body, config);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  editNotas: async (payload: any, id: any, files?: FileList | Blob | null) => {
    try {
      if (!files) {
        const res = await api.put(`/notas/${id}`, payload);
        toast.success(res.data.msg);
        return res;
      }

      const formData = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(
            key,
            Array.isArray(value) ? JSON.stringify(value) : String(value),
          );
        }
      });

      if (files instanceof Blob) {
        formData.append("files", files, "audio.webm");
      } else {
        Array.from(files).forEach((file) => formData.append("files", file));
      }

      const res = await api.put(`/notas/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  delNotas: async (id: any) => {
    try {
      const res = await api.delete(`/notas/${id}`);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      return error.response;
    }
  },
  listNotasTemplates: async () => {
    try {
      const res = await api.get(`/notas/templates`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  createNotaTemplate: async (payload: any) => {
    try {
      const res = await api.post(`/notas/templates`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  updateNotaTemplate: async (id: number, payload: any) => {
    try {
      const res = await api.put(`/notas/templates/${id}`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  deleteNotaTemplate: async (id: number) => {
    try {
      const res = await api.delete(`/notas/templates/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  listTarefasTemplates: async () => {
    try {
      const res = await api.get(`/tarefas/templates`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  createTarefaTemplate: async (payload: any) => {
    try {
      const res = await api.post(`/tarefas/templates`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  updateTarefaTemplate: async (id: number, payload: any) => {
    try {
      const res = await api.put(`/tarefas/templates/${id}`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  deleteTarefaTemplate: async (id: number) => {
    try {
      const res = await api.delete(`/tarefas/templates/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getTimeline: async (id: any, type: any, payload: any) => {
    try {
      let url;

      if (type === "prospecting") {
        url = `/prospectings/timeline/${id}`;
      } else if (type === "pagamento") {
        url = `/pagamentos/${id}/timeline`;
      } else {
        url = `logs/timeline/${id}/${type}`;
      }

      const res = await api.post(url, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getTimelineController: async (id: any, payload: any) => {
    try {
      const res = await api.post(`/pagamentos/${id}/timeline`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getDepartamentos: async (page: number, perPage: number) => {
    try {
      const res = await api.get(
        `/departamentos?page=${page}&perPage=${perPage}`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getComentarios: async (id_tarefa: any, type: any) => {
    try {
      const res = await api.get(`/comentarios/list/${id_tarefa}/${type}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addComentarios: async (payload: any) => {
    try {
      const res = await api.post("/comentarios", payload);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  delComentarios: async (id: any) => {
    try {
      const res = await api.delete(`/comentarios/${id}`);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      return error.response;
    }
  },
  filterChecklistItems: async (payload: any) => {
    try {
      const res = await api.post(`/desk-checklist-items/filter`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addChecklistItem: async (payload: any) => {
    try {
      const res = await api.post(`/desk-checklist-items`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  updateChecklistItem: async (id: number, payload: any) => {
    try {
      const res = await api.put(`/desk-checklist-items/${id}`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  toggleChecklistItem: async (id: number) => {
    try {
      const res = await api.post(`/desk-checklist-items/${id}/toggle`, {});
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  deleteChecklistItem: async (id: number) => {
    try {
      const res = await api.delete(`/desk-checklist-items/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  // Desk Checklists
  filterChecklists: async (payload: any) => {
    try {
      const res = await api.post(`/desk-checklists/filter`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  createChecklist: async (payload: any) => {
    try {
      const res = await api.post(`/desk-checklists`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  updateChecklist: async (id: number, payload: any) => {
    try {
      const res = await api.put(`/desk-checklists/${id}`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  deleteChecklist: async (id: number) => {
    try {
      const res = await api.delete(`/desk-checklists/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  // Checklist Templates
  listChecklistTemplates: async () => {
    try {
      const res = await api.get(`/checklist-templates`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  createChecklistTemplate: async (payload: any) => {
    try {
      const res = await api.post(`/checklist-templates`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  updateChecklistTemplate: async (id: number, payload: any) => {
    try {
      const res = await api.put(`/checklist-templates/${id}`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  deleteChecklistTemplate: async (id: number) => {
    try {
      const res = await api.delete(`/checklist-templates/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addChecklistTemplateItem: async (templateId: number, payload: any) => {
    try {
      const res = await api.post(
        `/checklist-templates/${templateId}/items`,
        payload,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  updateChecklistTemplateItem: async (id: number, payload: any) => {
    try {
      const res = await api.put(`/checklist-template-items/${id}`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  deleteChecklistTemplateItem: async (id: number) => {
    try {
      const res = await api.delete(`/checklist-template-items/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};
